import React from 'react';
import { useNavigate } from 'react-router-dom';

const Unauthorized = () => {
    const navigate = useNavigate();

    return (
        <div className="d-flex align-items-center justify-content-center vh-100">
            <div className="text-center">
                <h1 className="display-1 fw-bold">403</h1>
                <p className="fs-3"> <span className="text-danger">Opps!</span> Access Denied.</p>
                <p className="lead">
                    You do not have permission to view this page.
                </p>
                <button className="btn btn-primary" onClick={() => navigate(-1)}>Go Back</button>
            </div>
        </div>
    );
};

export default Unauthorized;
